export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Проверить адрес"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите адрес"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Укажите блокчейн"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выполнить проверку"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Low Risk"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Medium Risk"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["High Risk"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отсутствует в черном списке"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Проверить другой адрес"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скачать PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите провайдера"])}
}